module.exports = __webpack_public_path__ + "static/Qcountr-transparent-6c819a84da1a9f343052d9c9347d5078.png";